// removed by extract-text-webpack-plugin
module.exports = {"form":"c-CheckoutForm__form"};